import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import ProductGrid from "../components/ProductGrid.jsx";
import { ShopContext } from "../context/shopContext.js";
import Layout from "../components/Layout.jsx";
// import MainMenu from "../components/MainMenu.jsx";
import SEO from "../components/SEO.jsx";

function SearchResultsPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Keep original query for display, but normalised for searching
  const rawQuery = (queryParams.get("query") || "").trim();
  const query = rawQuery;

  const { searchProducts } = useContext(ShopContext);

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const total = results.length;

  // Scroll to top once on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (!query) {
        setResults([]);
        return;
      }

      setLoading(true);
      const products = await searchProducts(query);
      setResults(products || []);
      setLoading(false);
    };

    fetchSearchResults();
  }, [query, searchProducts]);

  const title = query ? `Search results for “${rawQuery}”` : "Search";
  const description = query
    ? `Search results for “${rawQuery}” on This Belongs To.`
    : "Search products on This Belongs To.";

  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        path={
          query
            ? `/search?query=${encodeURIComponent(rawQuery)}`
            : "/search"
        }
        noindex
      />

      {/* <MainMenu /> */}

      <div className="p-8">
        <h1 className="text-center text-md italic mb-6">
          {query ? (
            <>
              Showing {total} Results for &quot;{rawQuery}&quot;
            </>
          ) : (
            "Search"
          )}
        </h1>

        {query ? (
          loading ? (
            <p className="text-center italic">Searching…</p>
          ) : results.length > 0 ? (
            <ProductGrid products={results} />
          ) : (
            <p className="text-center">No products found.</p>
          )
        ) : (
          <p className="text-center">Please enter a search term.</p>
        )}
      </div>
    </Layout>
  );
}

export default SearchResultsPage;
